import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { ReplaySubject, Subject, firstValueFrom, take, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';

import { SendAccountReceiverDto } from 'src/app/domain/models/dto/bank-account.dto';
import { BankDashDto } from 'src/app/domain/models/dto/bank.dto';
import { CorporateAccountDto } from 'src/app/domain/models/dto/corporate-account.dto';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { PaymentSucessInboundComponent } from 'src/app/pages/orders/shared/components/create-order/payment-sucess-inbound/payment-sucess-inbound.component';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { AuthenticationService } from 'src/app/shared/services';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-order-payment-inbound',
  templateUrl: './order-payment-inbound.component.html',
  styleUrls: ['./order-payment-inbound.component.scss'],
})
export class OrderPaymentInboundComponent implements OnInit {
  @Input() order: any;

  private readonly notifier: NotifierService;
  accountForm: FormGroup;
  boobleModalData: InboundOrderDto;
  banks: BankDashDto[] = [];
  company: CorporateAccountDto;
  loading: boolean;
  isMobile = false;

  public bankFilterCtrl = new FormControl('');
  public filteredBanks: ReplaySubject<BankDashDto[]> = new ReplaySubject<
    BankDashDto[]
  >(1);

  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;

  protected _onDestroy = new Subject<void>();

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  constructor(
    fb: FormBuilder,
    private modalService: BoobleModalService,
    private bankAccountService: BankAccountService,
    private readonly accountService: AuthenticationService,
    private corporateAccountService: CorporateAccountService,
    private ordersService: OrdersService,
    private bottomSheet: MatBottomSheet,

    notifierService: NotifierService
  ) {
    this.notifier = notifierService;

    this.accountForm = fb.group({
      name: ['', [Validators.required, Validators.pattern('.*\\S.*')]],
      number: ['', [Validators.required, Validators.pattern('.*\\S.*')]],
      agency: ['', [Validators.required, Validators.pattern('.*\\S.*')]],
    });
  }

  get accountFormControl() {
    return this.accountForm.controls;
  }

  get account(): any {
    const account = this.accountForm.getRawValue();
    return account;
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820 ? true : false;

    if (this.isMobile) {
      this.boobleModalData = this.order;
    }

    firstValueFrom(this.bankAccountService.getNewBanks()).then((value) => {
      this.banks = value.data;

      this.filteredBanks.next(this.banks);
    });

    this.bankFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanks();
      });

    this.corporateAccountService.get().subscribe((getResult) => {
      this.company = getResult.data;
      if (getResult.data?.bankAccount) {
        this.accountForm.controls['name'].setValue(
          getResult.data?.bankAccount?.name
        );
        this.accountForm.controls['agency'].setValue(
          getResult.data?.bankAccount?.agency
        );
        this.accountForm.controls['number'].setValue(
          getResult.data?.bankAccount?.number
        );
      }
    });
  }

  changeBank(event: any) {
    this.accountForm.controls['name'].setValue(event.value);
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  protected setInitialValue() {
    this.filteredBanks
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect.compareWith = (a: BankDashDto, b: BankDashDto) =>
          a && b && a.id === b.id;
      });
  }

  protected filterBanks() {
    if (!this.banks) {
      return;
    }
    let search = this.bankFilterCtrl.value;

    if (!search) {
      this.filteredBanks.next(this.banks);
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBanks.next(
      this.banks.filter((bank) => {
        const searchLower = search.toLowerCase();
        return (
          bank.name.toLowerCase().indexOf(searchLower) > -1 ||
          bank.code.indexOf(search) > -1
        );
      })
    );
  }

  closeModal() {
    if (this.isMobile) {
      this.bottomSheet.dismiss();
    } else {
      this.modalService.dismiss(null);
    }
  }

  sendAccountInbound() {
    const account = new SendAccountReceiverDto();

    let bank = this.banks.find((item: any) => item.name === this.account.name);

    account.orderId = this.boobleModalData.id;
    account.name = this.account.name;

    account.code = bank.code;

    account.agency = this.account.agency;
    account.number = this.account.number;

    this.loading = true;
    this.ordersService.sendAccountReceiver(account).subscribe({
      next: (res) => {
        this.ordersService.updateOrderView();
        if (this.isMobile) {
          this.bottomSheet.dismiss();
        }
        this.openPaymentSuccessModal();
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  openPaymentSuccessModal() {
    this.modalService.present(PaymentSucessInboundComponent);
  }
}
